import Switch from './switch.vue'
export type { SwitchProps } from './props'
export default Switch